import React, { useContext } from "react";
import AddBlogForm from "./components/AddBlogForm";
import { Routes, Route } from "react-router-dom";
import BlogDetails from "./components/BlogDetails";
import BlogList from "./components/BlogList";
import { BlogProvider } from "../../../BlogContext.jsx";
import { UserContext } from "../../../UserContext.js";
import { isBlogAdmin } from "../../../utils/blogUtils";

const BlogPage = () => {
  const { user } = useContext(UserContext);

  if (!isBlogAdmin(user)) {
    return <div className="p-6 text-red-600">Access denied.</div>;
  }

  return (
    <BlogProvider>
      <div className="min-h-screen bg-white p-6">
        <Routes>
          <Route
            path="/"
            element={
              <>
                <AddBlogForm />
                <hr className="mt-8 mb-12 text-gray-300" />
                <BlogList />
              </>
            }
          />
          <Route path="/blog/:blog_id" element={<BlogDetails />} />
        </Routes>
      </div>
    </BlogProvider>
  );
};

export default BlogPage;
